import React, { FormEvent, ReactNode, useContext, useEffect, useRef } from 'react';
import styles from './styles.module.scss';
import Loader from '../Loader';
// import { LayoutContext } from '@/context/LayoutContext';
import AppLink from '../AppLink';

type ButtonType = {
  // onClick?: () => void | ((e: FormEvent) => void) | ((e: FormEvent) => void);
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  icon?: ReactNode | null;
  children?: ReactNode | null;
  loading?: boolean;
  disabled?: boolean;
  type?: string;
  href?: string;
  style?: object;
  title?: string;
  showHover?: boolean;
  iconStyle?: boolean;
  showAnimation?: boolean;
  wrapperStyle?: string;
};
const Button = ({
  onClick,
  className = '',
  onMouseEnter,
  onMouseLeave,
  icon = null,
  children,
  loading = false,
  disabled = false,
  type = 'button',
  href = '',
  style = {},
  title = '',
  showHover = false,
  iconStyle = false,
  showAnimation = false,
  wrapperStyle = '',
}: ButtonType) => {
  // const { dir } = useContext(LayoutContext);
  const parentRef = useRef<HTMLDivElement | null>(null);
  // const childRef = useRef<HTMLButtonElement | HTMLAnchorElement | null>(null);
  // const childLinkRef = useRef<HTMLButtonElement | HTMLAnchorElement | null>(null);

  const childRef = useRef<HTMLButtonElement | null>(null); // for <button>
  const childLinkRef = useRef<HTMLAnchorElement | null>(null); // for AppLink (anchor)

  useEffect(() => {
    if (type == 'button') {
      if (!parentRef.current || !childRef.current) return;

      const childStyle = window.getComputedStyle(childRef.current);
      parentRef.current.style.borderRadius = childStyle.getPropertyValue('border-radius');
    } else {
      if (!parentRef.current || !childLinkRef.current) return;

      const childStyle = window.getComputedStyle(childLinkRef.current);
      parentRef.current.style.borderRadius = childStyle.getPropertyValue('border-radius');
    }
  }, []);

  return (
    <div
      ref={parentRef}
      className={`buttonParent ${showHover && styles.defaultWrapper}  ${showAnimation ? styles.wrapper : ''} ${wrapperStyle}`}
    >
      {type == 'button' ? (
        <button
          ref={childRef}
          style={style}
          onClick={!loading && !disabled ? onClick : () => {}}
          className={`${styles.container} buttonChild ${showHover && styles.containerHover} ${iconStyle && styles.iconStyle} ${disabled && `${styles.disabledButton} ${styles.fancy} disabled`} ${className}`}
          disabled={disabled}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {loading ? (
            <Loader containerclassname={`${styles.loader}`} />
          ) : (
            <div className={`${styles.content}`}>
              {icon && icon}
              {children}
            </div>
          )}
        </button>
      ) : (
        <AppLink
          ref={childLinkRef}
          href={href}
          className={`${styles.container} buttonChild ${styles.link} ${showHover && styles.containerHover}  ${iconStyle && styles.iconStyle} ${disabled && `${styles.disabledButton} ${styles.fancy} disabled`} ${className}`}
          title={title}
          // onClick={!loading ? onClick : () => {}}
        >
          {loading ? (
            <Loader containerclassname={`${styles.loader}`} />
          ) : (
            <div className={`${styles.content}`}>
              {icon && icon}
              {children}
            </div>
          )}
        </AppLink>
      )}
    </div>
  );
};

export default Button;
